/* ============================================================================
 * A PRANCHA · v1 (2026-08-03)
 * ============================================================================
 * O motor de conversão da coleção. Arquiteto não põe no carrinho — ele
 * ESPECIFICA. O cliente marca peças enquanto navega e manda a prancha inteira
 * pro WhatsApp, já formatada, para a consultora responder com o preço.
 *
 * Diretriz do founder (03-08): "O preço fica no WhatsApp, o gate é isca."
 * Por isso aqui não há preço nenhum — só peça, ateliê e a conversa. E o
 * cadastro aparece num único lugar: salvar a prancha para não perder.
 *
 * SUBSTITUI a lista de desejos: mesmo armazenamento (window.TothWishlist,
 * localStorage), mesma marcação de coração nos cards. O que muda é o destino.
 * Os dados de cada peça vêm de /products/{handle}.js sob demanda — o
 * armazenamento guarda só o handle, e assim nunca fica desatualizado.
 * ========================================================================== */
(function () {
  'use strict';

  var WA = '5518996714293';
  var cache = {};
  var painel = null;
  var pilula = null;
  var carregando = false;

  function loja() {
    var el = document.querySelector('[data-tprn-config]');
    return {
      wa: (el && el.getAttribute('data-wa')) || WA,
      logado: !!(el && el.getAttribute('data-logado') === '1')
    };
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── dados da peça, sob demanda e em cache ── */
  function peca(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        cache[handle] = {
          handle: handle,
          titulo: p.title || handle,
          atelie: p.vendor || '',
          img: img ? String(img).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '',
          url: p.url || ('/products/' + handle)
        };
        return cache[handle];
      })
      .catch(function () { return null; });
  }

  function itens() {
    if (!window.TothWishlist) return [];
    return window.TothWishlist.list() || [];
  }

  /* ── a pílula flutuante ── */
  function montaPilula() {
    if (pilula) return pilula;
    pilula = document.createElement('button');
    pilula.type = 'button';
    pilula.className = 'tprn-pill';
    pilula.setAttribute('data-tprn-pill', '');
    pilula.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'
      + '<path d="M4 7.5 12 3.5l8 4-8 4-8-4Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'
      + '<path d="M4 12.5 12 16.5l8-4M4 17 12 21l8-4" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>'
      + '</svg><span data-tprn-n></span>';
    pilula.addEventListener('click', abre);
    document.body.appendChild(pilula);
    return pilula;
  }

  function sincroniza() {
    var n = itens().length;
    var p = montaPilula();
    p.classList.toggle('is-on', n > 0);
    var s = p.querySelector('[data-tprn-n]');
    if (s) s.textContent = n === 1 ? 'A Prancha · 1 peça' : 'A Prancha · ' + n + ' peças';
    p.setAttribute('aria-label', 'Abrir A Prancha, ' + n + (n === 1 ? ' peça' : ' peças'));
    if (painel && painel.classList.contains('is-open')) desenha();
  }

  /* ── o painel ── */
  function montaPainel() {
    if (painel) return painel;
    painel = document.createElement('div');
    painel.className = 'tprn-modal';
    painel.setAttribute('data-tprn-modal', '');
    painel.innerHTML =
      '<div class="tprn-modal__fundo" data-tprn-fecha></div>'
      + '<div class="tprn-modal__folha" role="dialog" aria-modal="true" aria-label="A Prancha">'
      + '  <div class="tprn-modal__cab">'
      + '    <div><p class="tprn-kicker">A sua prancha</p><h2 class="tprn-tit" data-tprn-tit>Peças escolhidas</h2></div>'
      + '    <button type="button" class="tprn-x" data-tprn-fecha aria-label="Fechar">&#10005;</button>'
      + '  </div>'
      + '  <div class="tprn-lista" data-tprn-lista></div>'
      + '  <div class="tprn-pe" data-tprn-pe></div>'
      + '</div>';
    painel.addEventListener('click', function (e) {
      if (e.target.closest('[data-tprn-fecha]')) { fecha(); return; }
      var rm = e.target.closest('[data-tprn-rm]');
      if (rm && window.TothWishlist) {
        window.TothWishlist.remove(rm.getAttribute('data-tprn-rm'));
        return;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && painel.classList.contains('is-open')) fecha();
    });
    document.body.appendChild(painel);
    return painel;
  }

  function desenha() {
    var m = montaPainel();
    var lista = m.querySelector('[data-tprn-lista]');
    var pe = m.querySelector('[data-tprn-pe]');
    var tit = m.querySelector('[data-tprn-tit]');
    var arr = itens();
    tit.textContent = arr.length === 1 ? '1 peça escolhida' : arr.length + ' peças escolhidas';
    if (!arr.length) {
      lista.innerHTML = '<p class="tprn-vazio">Sua prancha está vazia. Toque no coração de qualquer peça para começar a montar a sua especificação.</p>';
      pe.innerHTML = '';
      return;
    }
    if (!carregando) {
      carregando = true;
      lista.innerHTML = '<p class="tprn-vazio">Reunindo as peças…</p>';
      Promise.all(arr.map(function (i) { return peca(i.handle); })).then(function (ps) {
        carregando = false;
        var bons = ps.filter(Boolean);
        lista.innerHTML = bons.map(function (p) {
          return '<div class="tprn-item">'
            + '<a class="tprn-item__f" href="' + esc(p.url) + '">'
            + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="56" height="56">' : '<span class="tprn-item__semfoto"></span>')
            + '</a>'
            + '<div class="tprn-item__t"><a href="' + esc(p.url) + '">' + esc(p.titulo) + '</a>'
            + (p.atelie ? '<em>' + esc(p.atelie) + '</em>' : '') + '</div>'
            + '<button type="button" class="tprn-item__x" data-tprn-rm="' + esc(p.handle) + '" aria-label="Tirar ' + esc(p.titulo) + ' da prancha">&#10005;</button>'
            + '</div>';
        }).join('');
        pe.innerHTML = rodape(bons);
      });
    }
  }

  function rodape(ps) {
    var cfg = loja();
    var linhas = ps.map(function (p, i) {
      return (i + 1) + '. ' + p.titulo + (p.atelie ? ' — ' + p.atelie : '')
        + '\n   ' + location.origin + p.url;
    }).join('\n');
    var msg = 'Olá! Montei uma prancha no site da Toth com '
      + ps.length + (ps.length === 1 ? ' peça' : ' peças') + ':\n\n'
      + linhas + '\n\nGostaria de saber condições e prazos.';
    var href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(msg);
    var salvar = cfg.logado ? ''
      : '<a class="tprn-btn tprn-btn--ghost" href="/account/register?return_url='
        + encodeURIComponent(location.pathname) + '">Salvar minha prancha</a>';
    return '<a class="tprn-btn tprn-btn--wa" href="' + esc(href) + '" target="_blank" rel="noopener" data-tprn-wa>'
      + '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.2-1.7-.9-2-1s-.5-.1-.7.1-.7 1-.9 1.2-.4.2-.7 0a8 8 0 0 1-2.4-1.5 9 9 0 0 1-1.6-2c-.2-.4 0-.5.1-.7l.5-.6.3-.6c.1-.2 0-.4 0-.6l-1-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.2.2 2.3 3.5 5.5 4.8 2.7 1.1 3.3.9 3.9.8.6 0 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.2-.6-.4Z"/><path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2Zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3 .8.8-3-.2-.3A8.2 8.2 0 1 1 12 20.2Z"/></svg>'
      + 'Falar com uma consultora</a>' + salvar
      + '<p class="tprn-nota">A consultora recebe a lista pronta, com as peças e os links — e responde com condições e prazos.</p>';
  }

  function abre() {
    var m = montaPainel();
    desenha();
    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var f = m.querySelector('.tprn-x');
    if (f) f.focus();
  }
  function fecha() {
    if (!painel) return;
    painel.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (pilula) pilula.focus();
  }

  function inicia() {
    if (!window.TothWishlist) return;
    sincroniza();
    document.addEventListener('toth-wishlist:change', sincroniza);
    window.TothPrancha = { abre: abre, fecha: fecha, sincroniza: sincroniza };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(inicia, 60); });
  } else {
    setTimeout(inicia, 60);
  }
})();
